export const PERCENTAGES_DO_NOT_SUM_TO_100 = 'Percentages do not sum to 100%';
